<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>

    <div class="col-12">
      <pbi-report :pagination="isPaginated" ref="dashboard" height="75vh" width="100%" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { name as userModuleName } from '@/modules/user/store'
import { api } from '@/core/api'
import pbiReport from '@/components/common/PowerBiReport'
import PageHeader from "@/components/common/page/PageHeader.vue";
import PaginatedBIReports from "@/utils/constants/paginatedBIReports";

export default {
  name: 'ViewDashboard',
  components: {
    PageHeader,
    pbiReport,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-chart-pie',
        title: '',
        routes: ['Inicio', 'Dashboard']
      },
    }
  },
  computed: {
    ...mapState(userModuleName, ['menuItemId']),
    isPaginated() {
      const urlParams = new URLSearchParams(window.location.search)
      return Object.values(PaginatedBIReports).includes(Number(urlParams.get('r')));
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search)
    const reportId = urlParams.get('r')

    const self = this

    api
      .get('api/dashboard/getdashboardembeddata?reportId=' + reportId)
      .then(async (res) => {
        this.page.title = res.data.name
        this.page.routes.push(res.data.name)

        this.$refs['dashboard'].render(
          res.data.id,
          res.data.embedToken.token,
          res.data.embedUrl,
          res.data.filterParameters
        )
      })
      .catch((err) => {
        self.ShowToast('Alerta', err.response.data.message, 'error')
      })
  },
  methods: {},
}
</script>

<style scoped>
.heading-col {
  margin: 15px 0 30px 0;
}

.embedTarget {
  height: 75vh;
  width: 100%;
}

.btn-outline-green {
  color: #2db782;
  border: 1px #2db782 solid;
  font-weight: normal;
}
</style>
